/**
 * 로그인 소스 타입 정의
 */
export type LoginSourceType = 'paywall' | 'signin_page' | 'popup' | 'direct'

/**
 * 현재 로그인이 어떤 소스에서 발생했는지 감지하는 함수
 */
export const getLoginSourceType = (): LoginSourceType => {
  if (typeof window === 'undefined') {
    return 'direct'
  }

  // SessionStorage에서 paywall 표시 여부 확인
  const paywallShown = sessionStorage.getItem('paywall_shown')
  if (paywallShown === 'true') {
    return 'paywall'
  }

  // URL 경로로 판단
  const pathname = window.location.pathname
  if (pathname.includes('/signin')) {
    return 'signin_page'
  }

  // Referrer나 기타 조건으로 popup 판단 가능
  // 현재는 간단하게 direct로 처리
  return 'direct'
}

/**
 * Paywall이 표시되었음을 기록
 */
export const markPaywallShown = (): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem('paywall_shown', 'true')
  }
}

/**
 * 로그인 완료 후 paywall 관련 세션 정리
 */
export const clearPaywallSession = (): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('paywall_shown')
  }
}
